import {ProfileEducation} from './profileEducation';

export const Education = ProfileEducation;
